var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402 402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: currentColor;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 310,
    cy: 91.9,
    r: 46.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.6,0c-52.4.8-101.7,21.7-138.8,58.9C-14.2,131.8-19.2,247.3,43.6,326.1l66.9-66.9c-26.8-41.6-22-97.8,14.4-134.1,19.8-19.9,46.2-31,74.2-31.5,25.8-.4,46.4-21.7,46-47.5C244.7,20.2,223.5-.3,197.6,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.9,156.8h-.8c-25.5,0-46.3,20.5-46.8,46-.4,28-11.6,54.4-31.5,74.2-36.4,36.4-92.5,41.2-134.1,14.4l-66.9,66.9c36.5,29,80.8,43.6,125.1,43.6s102.9-19.6,142.1-58.8c37.1-37.1,58-86.4,58.9-138.9.4-25.8-20.2-47.1-46-47.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodify);
export default __webpack_public_path__ + "static/media/codify.692e94d7bb7f27532aa4bcd318bf9235.svg";
export { ForwardRef as ReactComponent };